/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { useEffect, useState, useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import { BorrowerLeadGenerationTool } from 'borrower-lead-generation-tool';
import styled from 'styled-components';

const StyledModalHeader = styled(Modal.Header)`
  padding: 0.5rem 1rem 0.5rem 1rem !important;
  background-color: #00aae4 !important;
  color: #fff !important;
  font-weight: 500 !important;
`;

const StyledModalBody = styled(Modal.Body)`
  .borrowerLeadGeneration .blg-col-0 {
    display: none;
  }
`;

const LeadFormModal = ({
  loanOfficerId,
  branchCode,
  leadSrc,
  loanPurpKeyword,
  formHeading,
  showLeadFormModal,
  onHide,
}) => {
  // stores the input field reference in a way that allows us to conditionally render
  // content or scroll to the element on button click.
  const [node, setNode] = useState(null);

  // watches for changes in the form.
  const formRef = useCallback(node => {
    // node refers to the name input field in the BorrowerLeadGenerationTool
    setNode(node);
  }, []);

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ zIndex: 10001 }}
      show={showLeadFormModal}
      onHide={onHide}
    >
      <StyledModalHeader closeButton>
        <Modal.Title>{formHeading}</Modal.Title>
      </StyledModalHeader>
      <StyledModalBody>
        <BorrowerLeadGenerationTool
          leadSource={leadSrc}
          loanOfficerUid={loanOfficerId}
          branch={branchCode}
          loanPurposeKeyword={loanPurpKeyword}
          statesDomain="ny.swmc.com"
          ref={formRef}
        />
      </StyledModalBody>
    </Modal>
  );
};

export default LeadFormModal;
